/**
 * A price impact is worth a warning when it is at least 1% and costs at
 * least a dollar; on a small order the reading is noise and the money at
 * stake is cents (John, Oct 29 2026: a 63 cent sale showed 1.47%).
 */
export function impactWarns(pct: number | null | undefined, valueUsd: number | undefined): pct is number {
  return pct !== null && pct !== undefined && pct >= 1 && valueUsd !== undefined && (valueUsd * pct) / 100 >= 1
}
